'use client';

import { useCallback } from 'react';

import { useRedirect } from 'hooks/use-redirect';

type ApiRedirectProps = {
	action: 'Redirect' | 'Display';
	url?: string | null;
	isConnect?: boolean;
};

export const useApiRedirect = () => {
	const redirect = useRedirect();

	const goToRedirect = useCallback(
		({ url, isConnect, action }: ApiRedirectProps) => {
			const isRedirect = action === 'Redirect';

			if (!isRedirect || !url) return;

			if (isConnect && url.startsWith('/connect')) {
				const absoluteUrl = `${window.location.origin}${url}`;
				return redirect({ path: absoluteUrl });
			}

			return redirect({ path: url });
		},
		[redirect]
	);

	return { goToRedirect };
};
